// extracted by mini-css-extract-plugin
export default {"-large":"nJRBo2j_bPLEK6Y5Pu1A","deleteIcon":"mqasCm7UtmbfdBED0frp","deleteConfirmIcon":"z9D4imrNioIhfG2cKLIA","cancelIcon":"YdefddI4iydw0nLhJlFb"};